import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/api/login', credentials),
  register: (userData) => api.post('/api/register', userData),
  me: () => api.get('/api/auth/me'),
  logout: () => api.post('/api/auth/logout'),
};

export const groupAPI = {
  getGroups: () => api.get('/api/groups'),
  createGroup: (data) => api.post('/api/groups/create', data),
  getGroupDetails: (id) => api.get(`/api/groups/details?id=${id}`),
};

export const memberAPI = {
  addMember: (data) => api.post('/api/members/add', data),
};

export const billAPI = {
  createBill: (data) => api.post('/api/bills/create', data),
  settleBill: (data) => api.post('/api/bills/settle', data),
  updateBill: (data) => api.put('/api/bills/update', data),
  deleteBill: (id) => api.delete(`/api/bills/${id}`),
};

export const shareAPI = {
  createLink: (data) => api.post('/api/share/create', data),
  getData: (token) => api.get(`/api/share/${token}`),
};

export const notificationAPI = {
  getNotifications: () => api.get('/api/notifications'),
  markAllRead: () => api.post('/api/notifications/read'),
  markRead: (id) => api.post(`/api/notifications/read/${id}`),
};

export function formatApiError(detail) {
  if (detail == null) return 'Terjadi kesalahan. Silakan coba lagi.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export default api;
